import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { loadVehicleFieldsValidationFailed, loadVehicleFieldsValidationSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* loadVehicleFieldsValidation(action) {
  try {
    const {
      id,
      data,
    } = action.payload;
    const url = `${BACKEND_URL}/proxy/backend/api/v1/registries/vehicles/${id}/fields-validation`;
    const dataResponse = yield makeRequest(url, data, action, 'POST', true);
    if (dataResponse.status === OK) {
      const data = yield dataResponse.json();
      yield put(loadVehicleFieldsValidationSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(loadVehicleFieldsValidationFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(loadVehicleFieldsValidationFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
